import { Snackbar, Alert } from '@mui/material';
import { RootState } from 'app/store';
import { useDispatch, useSelector } from 'react-redux';
import { hideToast } from 'store/slices/toastSlice';
import { clearToast } from 'store/slices/loginSignupSlice';
import { useEffect, useRef } from 'react';

const Toast = () => {
  const dispatch = useDispatch();
  const loginSignupToast = useSelector((state: RootState) => state.loginSignup?.toast);
  const { open, message, severity } = useSelector((state: RootState) => state.toast);
  const prevToastRef = useRef<string | null>(null);

  // Only show if toast is different from previous one
  const currentToastKey = loginSignupToast?.message || (open ? message : null);
  const shouldShow = currentToastKey && currentToastKey !== prevToastRef.current;

  useEffect(() => {
    if (shouldShow) {
      prevToastRef.current = currentToastKey;
      const timer = setTimeout(() => {
        dispatch(clearToast());
        dispatch(hideToast());
        prevToastRef.current = null;
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [shouldShow, currentToastKey, dispatch]);

  const activeToast = loginSignupToast || (open ? { message, severity } : null);

  if (!activeToast || !shouldShow) return null;

  return (
    <Snackbar
      open={true}
      autoHideDuration={3000}
      onClose={() => {
        dispatch(clearToast());
        dispatch(hideToast());
        prevToastRef.current = null;
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={() => {
          dispatch(clearToast());
          dispatch(hideToast());
          prevToastRef.current = null;
        }} 
        severity={activeToast.severity || 'success'} 
        sx={{ width: '100%' }}
      >
        {activeToast.message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
